const $ = require('jquery');
const API_URL = 'https://ensemble.customchannels.net/api/channels/';
const ICECAST_LAMBDA_URL = 'https://lambda.customchannels.rocks/nowplaying?url=';

class IcecastNowPlaying {

  constructor(channel_id, stream_url){
    this.stream_url = stream_url;
    this.channel_id = channel_id;

    this.now_playing = {};
    this.last_track = null;
  }

  checkIcecast(callback){
    this.getIcecastMetadata((icecastData) => {
      if(icecastData.track !== this.last_track){
        this.getNowPlaying((data) =>{
          this.last_track = icecastData.track;
          this.now_playing = data;
          callback(this.now_playing);
        });
      }else{
        callback(this.now_playing);
      }
    });
  }

  getIcecastMetadata(callback){
    $.ajax({
      method: "GET",
      url: ICECAST_LAMBDA_URL + this.stream_url,
      async: true,
      beforeSend: function(xhr, status){
      },
      error: function(xhr, status, error){
        return console.error(xhr, status, error);
      },
      success: function(data, status, xhr){
        callback(data);
      }
    });
  }

  // get the now playing from the channel_id
  getNowPlaying(callback){
    $.ajax({
      method: "GET",
      url: API_URL + this.channel_id + '/recent',
      cache: false,
      async: true,
      beforeSend: function(xhr, status){
      },
      error: function(xhr, status, error){
        return console.error(xhr, status, error);
      },
      success: function(data, status, xhr){
        callback(data);
      }
    });
  }

}

export default IcecastNowPlaying;



// WEBPACK FOOTER //
// ./src/IcecastNowPlaying.js